import { render, staticRenderFns } from "./ClientsNotifications.vue?vue&type=template&id=79fd1bbc&"
import script from "./ClientsNotifications.vue?vue&type=script&lang=js&"
export * from "./ClientsNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports